import { useNavigate } from "react-router-dom";
import Button from "../../../../../components/Buttons/Button";
import CustomModal from "../../../../../components/Modal/CustomModal";

const SuccessMsg = ({ isOpen, onRequestClose }) => {
  const navigate = useNavigate();
  const handleClose = () => {
    navigate("/landing");
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="장애 접수 성공 모달"
    >
      <p className="mb-6 text-2xl font-semibold text-center">
        등록이 완료 되었습니다.
      </p>
      <p className="text-lg font-medium text-center mb-11 text-neutral-400">
        문의건이 정상 접수 되었습니다. <br /> 잠시만 기다려주시면 답변
        드리겠습니다.
      </p>
      <div className="flex">
        <Button size="sm" onClick={handleClose}>
          확인
        </Button>
      </div>
    </CustomModal>
  );
};

export default SuccessMsg;
